import { render, staticRenderFns } from "./ViewResellerProductPage.vue?vue&type=template&id=3fee09f0"
import script from "./ViewResellerProductPage.vue?vue&type=script&lang=js"
export * from "./ViewResellerProductPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports